module.exports = __webpack_public_path__ + "static/media/sort.0b4cfd4a.svg";